import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "./../../utils/Modal";
import Swal from "sweetalert2";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CouponListItem = (props) => {
  const {
    coupons,
    index,
    loadingCallback,
    setSuccessFlashMessage,
    getCouponList,
    navigate,
  } = props;

  const token = localStorage.getItem("token");
  const [showCouponViewModal, setShowCouponViewModal] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [showCouponEditModal, setShowCouponEditModal] = useState(false);

  const handleCouponViewOpen = (id, coupon) => {
    getCouponView(id);
    setCoupon(coupon);
  };

  const getCouponView = (id) => {
    setShowCouponViewModal(true);
  };

  const handleCouponEditOpen = (coupon) => {
    setCoupon(coupon);
    setShowCouponEditModal(true);
  };

  const showModalBeforeDelete = (id, index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id);
      }
    });
  };

  const handleDelete = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}delete-coupon/${id}`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          getCouponList();
          notify("Coupon deleted successfully", "success");
        }
      })
      .catch((error) => {
        console.error(
          "Error deleting Coupon:",
          error.response?.data || error.message
        );

        // Handle unauthorized errors (e.g., token expired)
        if (error.response?.status === 401) {
          localStorage.clear();
          localStorage.setItem("token", false);
          localStorage.setItem("isPinVerify", false);
          navigate("/login");
        } else {
          notify("Failed to delete coupon. Please try again.", "error");
        }
      });
  };
  const notify = (msg, type) => {
    if (type == "success") {
      toast.success(msg, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { zIndex: 9999 },
      });
    }
    if (type == "error") {
      toast.error(msg, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { zIndex: 9999 },
      });
    }
  };

  return (
    <>
      {console.log(coupons)}
      <div>
        <div
          key={index}
          className="grid grid-cols-5 md:gap-5  gap-2 items-center font-nunito font-[500] text-[14px] text-[#000232] border-t-[1px] border-solid border-[#E7EBF4] py-[8px]"
        >
          {/* <div className="border-t-[1px] border-solid border-[#E7EBF4] py-[8px] font-nunito font-[500] text-[#000232] grid grid-cols-7 items-start"> */}
          <div>
            <div className="">
              {/* <div className="font-nunito text-[14px]"> */}
              <div className="font-[500] text-[#000232]">#{index + 1}</div>
              <div className="font-[700] text-[#87889E]">{coupons.coupon_name}</div>
              {/* </div> */}
            </div>
          </div>
          {/* <div className="text-center">{blogs.catogory_name}</div> */}
          <div className="text-center">
            {coupons.used_count === coupons.usage_limit ? (
              <span className="text-red-500 font-semibold">Limit Reached</span>
            ) : new Date(coupons.expire_date) < new Date() ? (
              <span className="text-red-500 font-semibold">Expired</span>
            ) : (
              <span className="text-green-600 font-semibold">Active</span>
            )}
          </div>
          <div className="text-center">
            {new Date(coupons.expire_date).toISOString().split("T")[0]}
          </div>
          <div className="text-center">
            {new Date(coupons.created_at).toISOString().split("T")[0]}
          </div>
          <div className="flex gap-2  text-xs justify-end">
            <label
              htmlFor="view_blog_modal"
              // onClick={()=>setShowViewModal(val=>!val)}
              //onClick={()=> Swal.fire("View option coming soon")}
              onClick={() => handleCouponViewOpen(coupons?.id, coupons)}
              className="cursor-pointer border-[1px] border-solid border-[#407BFF] text-[#407BFF] rounded-[5px] px-[6px] py-1"
            >
              VIEW
            </label>
            <label
              htmlFor="edit_blog_modal"
              //onClick={()=> Swal.fire("Edit option coming soon")}
              onClick={() => handleCouponEditOpen(coupons)}
              className="cursor-pointer border-[1px] border-solid bg-[#407BFF] border-[#407BFF] text-white rounded-[5px] px-[7px] py-1"
            >
              EDIT
            </label>
            <label
              // htmlFor="editAccTxn_modal"
              // onClick={()=> Swal.fire("Edit option coming soon")}
              onClick={() => showModalBeforeDelete(coupons?.id)}
              className="cursor-pointer border-[1px] border-solid bg-[#FF0303] text-white rounded-[5px] px-[7px] py-1"
            >
              DELETE
            </label>
          </div>
        </div>
      </div>

      {showCouponViewModal ? (
        <Modal
          isOpen={showCouponViewModal}
          setOpen={setShowCouponViewModal}
          //setWarningMessage={setWarningMessage}
          title="Coupon Details"
          formId="viewCouponModal"
          loadingCallback={loadingCallback}
          //navigate={navigate}
          type="viewCouponModal"
          coupon={coupon}
        />
      ) : null}

      {showCouponEditModal ? (
        <Modal
          isOpen={showCouponEditModal}
          setOpen={setShowCouponEditModal}
          //setWarningMessage={setWarningMessage}
          title="Edit Coupon"
          formId="edit_coupon_modal"
          //loadingCallback={loadingCallback}
          //navigate={navigate}
          type="edit_coupon_modal"
          //formData={editFormData}
          //setFormData={setEditFormData}
          coupon={coupon}
          notify={notify}
          //refetch={()=>setRefetch(val=>!val)}
          getCouponList={getCouponList}
        />
      ) : null}
    </>
  );
};

export default CouponListItem;